var _g, _rect, _rect2, _rect3, _g2, _g3, _rect4, _rect5, _rect6, _g4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionsLoadingSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 80,
    viewBox: "0 0 280 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9471_10996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 260,
    height: 24,
    rx: 2,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 20.2143,
    y: 15.168,
    width: 13.7054,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.0825,
    y: 15.168,
    width: 166,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 206.245,
    y: 15.168,
    width: 34,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9471_10996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.881 12H257.548C257.724 12 257.894 12.0702 258.019 12.1953C258.144 12.3203 258.214 12.4899 258.214 12.6667V23.3333C258.214 23.5101 258.144 23.6797 258.019 23.8047C257.894 23.9298 257.724 24 257.548 24H246.881C246.704 24 246.535 23.9298 246.41 23.8047C246.285 23.6797 246.214 23.5101 246.214 23.3333V12.6667C246.214 12.4899 246.285 12.3203 246.41 12.1953C246.535 12.0702 246.704 12 246.881 12ZM251.55 20.6667L256.263 15.9527L255.32 15.01L251.55 18.7813L249.664 16.8953L248.721 17.838L251.55 20.6667Z",
    fill: "#121B2E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9471_10996)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 42,
    width: 260,
    height: 24,
    rx: 2,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 20.2143,
    y: 51.168,
    width: 71,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 94.3771,
    y: 51.168,
    width: 32,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129.54,
    y: 51.168,
    width: 110,
    height: 6,
    rx: 3,
    fill: "#EBEBEF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9471_10996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.881 48H257.548C257.724 48 257.894 48.0702 258.019 48.1953C258.144 48.3203 258.214 48.4899 258.214 48.6667V59.3333C258.214 59.5101 258.144 59.6797 258.019 59.8047C257.894 59.9298 257.724 60 257.548 60H246.881C246.704 60 246.535 59.9298 246.41 59.8047C246.285 59.6797 246.214 59.5101 246.214 59.3333V48.6667C246.214 48.4899 246.285 48.3203 246.41 48.1953C246.535 48.0702 246.704 48 246.881 48ZM251.55 56.6667L256.263 51.9527L255.32 51.01L251.55 54.7813L249.664 52.8953L248.721 53.838L251.55 56.6667Z",
    fill: "#121B2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9471_10996",
    x: 0,
    y: 0,
    width: 280,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9471_10996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9471_10996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9471_10996",
    x: 0,
    y: 36,
    width: 280,
    height: 44,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9471_10996"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9471_10996",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9471_10996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(244.214 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9471_10996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(244.214 46)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsLoadingSmall);
export default __webpack_public_path__ + "static/media/permissions_loading_small.bdee7b74d207b982ed74639e4c6a55d5.svg";
export { ForwardRef as ReactComponent };